import { useEffect, useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

function OrderHistory() {

    const [orders, setOrders] = useState([]);
    const navigate = useNavigate()

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const res = await API.get("/api/order/history");
            console.log(res.data)
            setOrders(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="container mt-4">

            <h3 className="mb-4">My Orders</h3>

            {orders.length === 0 ? (
                <h5>No orders found</h5>
            ) : (
                orders.map((order) => (
                    <div key={order.id} className="card mb-4 shadow-sm p-3" style={{ cursor: "pointer" }} onClick={()=> navigate(`/order/${order.id}`)}>

                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="mb-1">Order #{order.id}</h6>
                                <small className="text-muted">
                                    {new Date(order.orderDate).toLocaleString()}
                                </small>
                            </div>

                            <span className={`badge ${order.orderStatus === "DELIVERED" ? "bg-success" :
                                    order.orderStatus === "CANCELLED" ? "bg-danger" :
                                        "bg-warning text-dark"
                                }`}>
                                {order.orderStatus}
                            </span>
                        </div>

                        <hr />

                        {order.items?.map((item) => (
                            <div key={item.productId} className="d-flex align-items-center mb-3">

                                <img
                                    src={item.imageUrl || "/default.png"}
                                    alt={item.productName}
                                    style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                    className="me-3"
                                />

                                <div className="flex-grow-1">
                                    <h6 className="mb-1">{item.productName}</h6>
                                    <p className="mb-0 text-muted">
                                        Qty: {item.quantity}
                                    </p>
                                </div>

                                <div>
                                    ₹ {item.price}
                                </div>
                            </div>
                        ))}

                        <hr />

                        <div className="d-flex justify-content-between">
                            <div>
                                <strong>Deliver To:</strong>
                                <p className="mb-1">
                                    {order.address.fullName}
                                </p>
                                <p className="text-muted mb-0">
                                    {order.address.street}<br/>
                                    {order.address.city}
                                </p>
                            </div>

                            <div className="text-end">
                                <p className="mb-1">
                                    <strong>{order.paymentMethod}</strong>
                                </p>
                                <p className="text-muted mb-0">
                                    {order.paymentStatus}
                                </p>
                                <h6 className="mt-2">₹ {order.totalPrice}</h6>
                            </div>
                        </div>

                    </div>
                ))
            )}

        </div>
    );
}

export default OrderHistory;